/**
 * TODO: Refactor all of unsaved changes in all the routes and bring them under
 * 1 logic.
 * In the mean time, this enum accounts for all possible responses that the
 * user can provide to unsaved changes dialog.
 */
export enum UnsavedChangesDialogResponse {
  /** Unsaved Changes - user choose to save and move forward. */
  saveAndContinue = 0,
  /** Unsaved Changes - user choose to just cancel the save and move forward. */
  cancelAndContinue = 1,
  /** Unsaved Changes - user choose to just cancel the further operations and stay there. */
  dismissViaXButton = 2,
  /** No unsaved Changes */
  noNeedForDialog = 3,
}
